import { http } from '@/core/api/';
import qs from 'qs';

const apiUrl = 'api/compuappointment';

export default {
  async fetchPurposes() {
    const { status, data: response } = await http.get(`${apiUrl}/purposes`);
    return status !== 200 ? [] : response;
  },
  async fetchStatuses() {
    const { status, data: response } = await http.get(`${apiUrl}/statuses`);
    return status !== 200 ? [] : response;
  },
  fetchAttendanceResponses() {
    return http.get(`${apiUrl}/attendance-responses`);
  },
  fetchPurposeOptions(studentSieId, citationNumber) {
    return http.get(`${apiUrl}/students/${studentSieId}/purpose-options`, {
      params: { citationNumber },
    });
  },
  fetchActivePurposeReminder(studentSieId, purposeId, excludeAppointmentId) {
    return http.get(`${apiUrl}/students/${studentSieId}/active-purpose-reminder`, {
      params: { purposeId, excludeAppointmentId },
    });
  },
  fetchPurposeReminders(studentSieId, purposeIds, excludeAppointmentId) {
    return http.get(`${apiUrl}/students/${studentSieId}/purpose-reminders`, {
      params: { purposeIds, excludeAppointmentId },
      paramsSerializer: (requestParams) =>
        qs.stringify(requestParams, { arrayFormat: 'repeat' }),
    });
  },
  async fetchCalendar(params) {
    const requestParams = Object.entries(params || {}).reduce(
      (accumulator, [key, value]) => {
        if (value === null || value === undefined || value === '') {
          return accumulator;
        }

        if (Array.isArray(value) && !value.length) {
          return accumulator;
        }

        accumulator[key] = value;
        return accumulator;
      },
      {}
    );

    const { status, data: response } = await http.get(`${apiUrl}/calendar`, {
      params: requestParams,
      paramsSerializer: (requestParams) =>
        qs.stringify(requestParams, { arrayFormat: 'repeat' }),
    });

    return status !== 200 ? { items: [] } : response;
  },
  searchStudents(searchText) {
    return http.get(`${apiUrl}/students/search`, {
      params: { searchText },
    });
  },
  fetchStudentHistory(studentSieId) {
    return http.get(`${apiUrl}/students/${studentSieId}/history`);
  },
  fetchCoordinatedAppointments(payload) {
    return http.get(`${apiUrl}/coordinated-appointments`, {
      params: payload,
    });
  },
  getMinuteById(id) {
    return http.get(`${apiUrl}/minute-edited/${id}`);
  },
  fetchParticipantOptions(studentSieId, citationNumber) {
    return http.get(`${apiUrl}/students/${studentSieId}/participant-options`, {
      params: { citationNumber },
    });
  },
  fetchPendingEvaluations(studentSieId) {
    return http.get(`${apiUrl}/students/${studentSieId}/pending-evaluations`);
  },
  saveAppointment(dto) {
    return http.post(`${apiUrl}/save`, dto, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  recoordinateAppointment(id, dto) {
    return http.post(`${apiUrl}/${id}/recoordinate`, dto, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  registerCelebration(id, dto) {
    return http.post(`${apiUrl}/${id}/celebration`, dto);
  },
  fetchCompletedMinutes(id) {
    return http.get(`${apiUrl}/${id}/completed-minutes`);
  },
  confirmManuscriptAppointment(id, dto) {
    return http.post(`${apiUrl}/${id}/confirm-manuscript`, dto, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getAppointmentInfo(id) {
    return http.get(`${apiUrl}/info/${id}`);
  },
  getCompuMeetingCoordinationUrl(id) {
    return http.get(`${apiUrl}/sign-compu-meeting-coordination-url/${id}`);
  },
};
